// The platform-wide Invited and Deactivated tabs are UsersPanel server sources
// fetched by usePaginatedQuery. The endpoint is the fetch URL; the key factory
// owns the cache key. The tab passes both and the invalidating mutation
// references the same factory key, so the URL and cache key can't drift.
export const systemEndpoints = {
  users: () => '/users',
  invites: () => '/invites',
  deactivatedUsers: () => '/deactivated-users',
}

export const systemKeys = {
  summary: () => ['system', 'summary'] as const,
  // Entity-rooted list prefix (params appended by the query) — matches every
  // page / search variant of the platform-wide Invited list.
  invitesList: () => ['system', 'invites', 'list'] as const,
  sessions: () => ['system', 'sessions'] as const,
  workspaceSessions: () => ['system', 'sessions', 'workspaces'] as const,
  queues: () => ['system', 'queues'] as const,
  users: () => ['system', 'users'] as const,
  // The server-paginated active-users list (system-admin Members tab). Nested
  // under the `['system','users']` prefix — like deactivatedUsersList below — so
  // every mutation that invalidates that prefix (deactivate/reactivate, invite,
  // delete, profile edits) cascades to this list too.
  usersList: () => ['system', 'users', 'list'] as const,
  // Nested under the `['system','users']` prefix (unlike the org/workspace
  // sibling convention) so every existing mutation that invalidates that prefix
  // — deactivate/reactivate, invite, profile edits — cascades to this list too.
  deactivatedUsersList: () =>
    ['system', 'users', 'deactivated', 'list'] as const,
  workspaces: () => ['system', 'workspaces'] as const,
  simulations: () => ['system', 'simulations'] as const,
  characters: () => ['system', 'characters'] as const,
}
